var map = {
	"./1.jpg": 7013,
	"./10.jpg": 5433,
	"./11.jpg": 8060,
	"./12.jpg": 5755,
	"./2.jpg": 6026,
	"./3.jpg": 8679,
	"./4.jpg": 1244,
	"./5.jpg": 8617,
	"./6.jpg": 2478,
	"./7.jpg": 8939,
	"./8.jpg": 4032,
	"./9.jpg": 1133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9377;